var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookMyShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -17,
    y: -17,
    width: 108,
    height: 108
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8.5px)",
      clipPath: "url(#bgblur_0_926_8876_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 17
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 8,
    fill: "#0F1E53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 73,
    height: 73,
    rx: 8.5,
    stroke: "#1A1A1A",
    strokeOpacity: 0.09
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_926_8876)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 56,
    height: 56,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.68 29.7501L50.8425 26.5392L47.576 28.1539L45.7385 24.943L42.472 26.5577L40.6345 23.3469L37.368 24.9616L35.5305 21.7507L32.264 23.3654L30.4265 20.1545L27.16 21.7693L20.2 45.0064L28.6262 47.6605C29.183 45.7859 30.8905 44.4125 32.895 44.4125C35.3635 44.4125 37.368 46.4726 37.368 49.0153V49.1081C37.3865 49.5165 37.3494 49.9433 37.2195 50.3517L45.7942 53.0614",
    fill: "#D70B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4198 43.0762C26.9743 43.0019 26.6774 42.6122 26.6774 42.1482V30.7338C26.6774 30.1955 27.0857 29.7872 27.6054 29.7872H35.5862C35.7903 29.7872 35.9945 29.8058 36.1986 29.8429C37.9062 30.1584 39.1682 31.6804 39.1682 33.4807V42.1482C39.1682 42.408 39.0754 42.6493 38.8898 42.8349C38.7228 43.002 38.4815 43.1133 38.2402 43.1133L38.0732 43.0948C37.6278 43.0205 37.3308 42.6308 37.3308 42.1668V33.5178C37.3308 32.6455 36.7183 31.9031 35.8831 31.7546L35.5862 31.7175H33.8415V42.1668C33.8415 42.4266 33.7487 42.6679 33.5631 42.8535C33.3961 43.0205 33.1548 43.1319 32.9135 43.1319L32.7465 43.1133C32.301 43.0391 32.0041 42.6493 32.0041 42.1853V31.7175H28.5148V42.1668C28.5148 42.4266 28.422 42.6679 28.2364 42.8349C28.0694 43.002 27.8281 43.1133 27.5868 43.1133L27.4198 43.0762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6902 48.0503C40.2447 47.976 39.9478 47.5863 39.9478 47.1223C39.9478 46.8624 40.0406 46.6212 40.2076 46.4541C40.3746 46.2871 40.6159 46.1757 40.8572 46.1757C41.6367 46.1757 42.3049 45.656 42.5276 44.8951L43.4742 41.6285L40.3746 30.9194C40.2262 30.4183 40.5046 29.88 40.9871 29.713L41.3954 29.6944C41.7295 29.7501 42.0079 30.01 42.1193 30.344L44.4207 38.3248L46.7593 30.344C46.8706 29.8986 47.3346 29.6016 47.8172 29.6944L47.8729 29.713C48.374 29.88 48.6524 30.4183 48.4854 30.9194L45.293 41.9069L44.2908 45.4333C44.031 46.25 43.5855 46.8996 42.9916 47.345C42.3606 47.8276 41.6182 48.0874 40.8386 48.0874L40.6902 48.0503Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_926_8876_clip_path",
    transform: "translate(17 17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_926_8876"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMyShow);
export default __webpack_public_path__ + "static/media/BookMyShow.3dc316c8791debbabca91459b3bc58d3.svg";
export { ForwardRef as ReactComponent };